<template>
  <div class="uap" :class="'uap--' + userProfile.member.levelKey">
    <div class="uap-accent"></div>

    <div class="uap-profile">
      <div class="uap-avatar-wrap">
        <el-avatar :size="52" icon="el-icon-user-solid" class="uap-avatar"></el-avatar>
        <span v-if="userProfile.member.isVip" class="uap-vip-dot"></span>
      </div>
      <div class="uap-profile-main">
        <div class="uap-name">{{ userProfile.username }}</div>
        <div class="uap-email">{{ userProfile.email }}</div>
      </div>
    </div>

    <div class="uap-member-card">
      <div class="uap-member-head">
        <div class="uap-member-badge">{{ userProfile.member.levelName }}</div>
        <span
          class="uap-member-status"
          :class="{ 'is-warning': memberExpiringSoon, 'is-vip': userProfile.member.isVip && !memberExpiringSoon }"
        >{{ memberStatusLabel }}</span>
      </div>

      <div class="uap-member-grid">
        <div class="uap-member-item">
          <span class="uap-member-item-label">到期时间</span>
          <span class="uap-member-item-value">{{ memberExpireText }}</span>
        </div>
        <div class="uap-member-item">
          <span class="uap-member-item-label">剩余时长</span>
          <span
            class="uap-member-item-value"
            :class="{ 'is-warning': memberExpiringSoon }"
          >{{ memberRemainText }}</span>
        </div>
      </div>

      <div v-if="userProfile.member.isVip && memberDaysLeft !== null" class="uap-progress">
        <div class="uap-progress-bar">
          <div
            class="uap-progress-fill"
            :class="{ 'is-warning': memberExpiringSoon }"
            :style="{ width: memberProgressPercent + '%' }"
          ></div>
        </div>
      </div>
    </div>

    <div class="uap-actions">
      <button type="button" class="uap-action" @click="$emit('navigate', '/member/usage')">
        <span class="uap-action-icon uap-action-icon--blue"><i class="el-icon-data-analysis"></i></span>
        <span class="uap-action-label">会员用量</span>
      </button>
      <button type="button" class="uap-action" @click="$emit('navigate', '/member/upgrade')">
        <span class="uap-action-icon uap-action-icon--gold"><i class="el-icon-star-on"></i></span>
        <span class="uap-action-label">升级会员</span>
      </button>
      <button
        v-if="canUpgradeDiff"
        type="button"
        class="uap-action"
        @click="$emit('navigate', '/member/upgrade-diff')"
      >
        <span class="uap-action-icon uap-action-icon--blue"><i class="el-icon-s-finance"></i></span>
        <span class="uap-action-label">补差升级</span>
      </button>
      <button type="button" class="uap-action" @click="$emit('navigate', '/user/settings')">
        <span class="uap-action-icon uap-action-icon--gray"><i class="el-icon-setting"></i></span>
        <span class="uap-action-label">个人中心</span>
      </button>
    </div>

    <button
      v-if="!userProfile.member.isVip || memberExpiringSoon"
      type="button"
      class="uap-upgrade-btn"
      @click="$emit('upgrade')"
    >
      {{ userProfile.member.isVip ? '续费会员' : '开通会员' }}
    </button>

    <div class="uap-footer">
      <button type="button" class="uap-logout" @click="$emit('logout')">
        <i class="el-icon-switch-button"></i>
        退出登录
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAccountPanel',
  props: {
    userProfile: { type: Object, required: true },
    memberExpireText: { type: String, default: '—' },
    memberRemainText: { type: String, default: '—' },
    memberDaysLeft: { type: Number, default: null },
    memberExpiringSoon: { type: Boolean, default: false },
    memberProgressPercent: { type: Number, default: 0 }
  },
  computed: {
    memberStatusLabel() {
      if (!this.userProfile.member.isVip) return '免费版'
      if (this.memberExpiringSoon) return '即将到期'
      return '使用中'
    },
    canUpgradeDiff() {
      const m = this.userProfile && this.userProfile.member
      if (!m || !m.isVip) return false
      const hydj = String(m.hydj != null ? m.hydj : '')
      if (hydj === '3' || hydj === '99') return false
      const key = m.levelKey || ''
      if (key === 'advanced' || key === 'special') return false
      return true
    }
  }
}
</script>
